// extracted by mini-css-extract-plugin
export default {"frame":"manualTest_frame__iiqbq","div":"manualTest_div__aa2K9","aria-attributes":"manualTest_aria-attributes__BbJBJ","img":"manualTest_img__mvBWC"};